import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, Col } from 'react-bootstrap';
import map from 'lodash/map';
import humanizeString from 'humanize-string';
import titleize from 'titleize';

import SelectableRecordsTable from 'components/selectable_record_table/selectable_record_table';
import SelectableRow from 'components/selectable_record_table/selectable_row';

export default class EnumFieldMapper extends React.Component {
  static propTypes = {
    buildoutField: PropTypes.string.isRequired,
    buildoutFieldLabel: PropTypes.string.isRequired,
    enumMapping: PropTypes.object.isRequired,
    enumValues: PropTypes.object.isRequired,
    onUpdateEnumMapping: PropTypes.func.isRequired
  }

  handleUpdateEnumMapping = (e, buildoutField, importedValue) => {
    const { value } = e.target;

    this.props.onUpdateEnumMapping(buildoutField, importedValue, value.length > 0 ? value : null);
  }

  enumMappingColumnHeaders = (
    <React.Fragment>
      <th>Buildout Value</th>
      <th>Imported Value</th>
    </React.Fragment>
  )

  render() {
    const { enumMapping, buildoutFieldLabel } = this.props;

    return (
      <Col md={6} sm={12}>
        <h4 className="mt-0 text-center">
          Please specify the mapping for <strong>{buildoutFieldLabel}</strong>
        </h4>
        <SelectableRecordsTable
          className="field-mapping-table mb-5"
          columnHeaders={this.enumMappingColumnHeaders}
          hasSelectAll={false}
          hasSelectColumn={false}
          name="enumMappingTable"
        >
          {map(enumMapping, (buildoutValue, importedValue) => this.renderEnumMappingRow(buildoutValue, importedValue))}
        </SelectableRecordsTable>
      </Col>
    );
  }

  renderEnumMappingRow(buildoutValue, importedValue) {
    const { buildoutField, enumValues } = this.props;

    return (
      <SelectableRow hideCheckbox key={importedValue}>
        <td>
          <FormControl
            className={buildoutValue == null ? 'bg-warning' : ''}
            componentClass="select"
            name="buildoutValueSelect"
            value={buildoutValue || ''}
            onChange={e => this.handleUpdateEnumMapping(e, buildoutField, importedValue)}
          >
            <option key="blank" value="">Select a field</option>
            {map(enumValues, (value, label) => <option key={label} value={value}>{titleize(humanizeString(label))}</option>)}
          </FormControl>
        </td>
        <td name="importedValue">{importedValue}</td>
      </SelectableRow>
    );
  }
}
